import { combineReducers } from 'redux';
import { APIReducer } from 'store/apiReducer';
import {
    CONTEXT_COMPLETER_AJOUT_CERTIFICAT_MEDICAL,
    CONTEXT_COMPLETER_DEMANDE_PIECES_JOINTES,
    CONTEXT_GET_DECLARATIONS_ARMES,
    CONTEXT_GET_DECLARATIONS_ARMES_ALL,
    CONTEXT_GET_LISTE_PIECES_MANQUANTES_DECLARATION_ARMES,
} from '../../constants/apiUrls.constants';

const mesDeclarationsArmes = combineReducers({
    declarationsArmesAll: APIReducer.bind(null, CONTEXT_GET_DECLARATIONS_ARMES_ALL),
    declarationsArmes: APIReducer.bind(null, CONTEXT_GET_DECLARATIONS_ARMES),
    listePiecesManquantesDeclarationArme: APIReducer.bind(
        null,
        CONTEXT_GET_LISTE_PIECES_MANQUANTES_DECLARATION_ARMES,
    ),
    envoyerDemandePjs: APIReducer.bind(null, CONTEXT_COMPLETER_DEMANDE_PIECES_JOINTES),
    envoyerCertificatMedicalPj: APIReducer.bind(null, CONTEXT_COMPLETER_AJOUT_CERTIFICAT_MEDICAL),
});

export default mesDeclarationsArmes;
